/* global $:true module:true Flickity:true Foundation:true */
import debug from "debug";
const ZERO = 0;
const MODULE_NAME = 'core/modules/sliders/blocks';
const log = debug(MODULE_NAME);


function setSlideHeights() {
	log('setSlideHeights');

	$('.block-slider')
		.each(function ReduceSliderHeightFn () {
			const slider = $(this);
			let height = 0;

			$(slider).find('.slide-cell')
				.css('height', 'auto');

			$(slider).find('.slide-cell')
				.each(function FindSlideHeight () {
					const cell = $(this);
					const cellHeight = cell.height();
					if (cellHeight > height) {
						height = cellHeight;
					}
				});

			$(slider).find('.slide-cell')
				.css('height', height);

			$(slider).addClass('height-set');

		});
}

function setupSliders() {
	log('setupSliders');

	$('.block-slider')
		.each(function SetupSlider () {
			const slider = $(this);
			const sliderElement = $(slider).get(ZERO);
			// const wrapAround = $(slider).attr('data-wrap-around') === 'true';
			const autoPlay = $(slider).attr('data-auto-play') === 'true';

			const FlickityOptions = {
					autoPlay: autoPlay,
					wrapAround: true,
					freeScroll: true,
					bgLazyLoad: true,
                    adaptiveHeight: false,
                    dragThreshold: 10,
					contain: true,
					cellAlign: 'left',
					groupCells: '100%',
					arrowShape: 'M74.38,92.74a4.24,4.24,0,1,1-6,6c-.5-.47-1-1-1.45-1.46l-8.87-8.86L31.94,62.29,23.68,54a9,9,0,0,1-1.88-2.21c-1-2-.12-3.9,1.32-5.34L43,26.63,66.08,3.52c.71-.71,1.41-1.42,2.12-2.12,2.24-2.2,6.14-1.73,7.2,1.47s-2.58,5.9-4.62,7.94l-24.6,24.6-11,11-3,3c-.09.09-.56.43-.57.56s.07.08.14.22.58.58.8.81L34,52.35l4.36,4.36L50.88,69.24,73.1,91.46Z'
			};

			const SliderInstance = new Flickity(sliderElement, FlickityOptions);
		});

	$(window).resize(() => {
		setSlideHeights();
	});
}

export default function () {
	setSlideHeights();
	setupSliders();
}



// WEBPACK FOOTER //
// ./project/client/src/core/modules/sliders/blocks.js